import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/core';

export interface ChipOption {
  id: string | number;
  label: string;
  disabled?: boolean;
}

interface OptionChipsProps {
  options: ChipOption[];
  /** Ids that are currently on. */
  selected: (string | number)[];
  onSelect: (id: string | number) => void;
}

// A row of toggle buttons. The editor wraps every tab in a <form>, so clicks must not submit it.
export const OptionChips = ({ options, selected, onSelect }: OptionChipsProps) => (
  <div className="d-flex flex-wrap">
    {options.map((o) => (
      <Button htmlType="button"
        key={o.id}
        size={ButtonSize.small}
        type={ButtonType.secondary}
        variant={selected.includes(o.id) ? ButtonVariant.contained : ButtonVariant.outline}
        className="me-2 mb-2"
        disabled={o.disabled}
        onClick={() => {
          onSelect(o.id);
        }}
      >
        {o.label}
      </Button>
    ))}
  </div>
);
